import { react2angular } from 'react2angular';
import { DashboardNavPageHeaderWrapper } from './DashboardNavPageHeaderWrapper';

angular
    .module('signalview.dashboardNavPageHeaderWrapper', [])
    .component(
        'dashboardNavPageHeaderWrapper',
        react2angular(DashboardNavPageHeaderWrapper, [
            'actions',
            'description',
            'groupEnabled',
            'hasDeleteDashboardGroupCapability',
            'isExportEnabled',
            'groupActions',
            'model',
            'modernDashboardsEnabled',
            'navigation',
            'onTrackClick',
            'showStatus',
        ])
    );
